"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEstimatedFraction = exports.fractionEstimateIntervals = exports.convertFractionToChar = exports.reduceFraction = void 0;
const trimAttributes_1 = require("./attributes/trimAttributes");
/**
 * // https://stackoverflow.com/a/4652513
 * Reduce a fraction to its simplest form
 * @param num fraction numerator
 * @param denom fraction denominator
 * @returns simplified numerator and denominator in array [X, Y]
 */
const reduceFraction = (num, denom) => {
    const gcdFunc = (a, b) => {
        return b ? gcdFunc(b, a % b) : a;
    };
    const gcd = gcdFunc(num, denom);
    return [num / gcd, denom / gcd];
};
exports.reduceFraction = reduceFraction;
/**
 * convert string fraction to a character if it exists,
 * e.g. 1/2 -> ½
 * @param val the string fraction
 * @returns simplified numerator and denominator in array [X, Y]
 */
const convertFractionToChar = (val) => {
    let strIndex = 0;
    let i = 0;
    let j = 0;
    let vals = [];
    if (!val)
        return '';
    strIndex = val.search(/^[0-9]+\/[0-9]+$/g);
    if (strIndex !== -1) {
        vals = val.substring(strIndex, val.length).split('/');
        i = parseInt(vals[0]);
        j = parseInt(vals[1]);
        const reduced = exports.reduceFraction(i, j).join('/');
        if (reduced in trimAttributes_1.Fractions)
            return trimAttributes_1.Fractions[reduced];
        else
            return val;
    }
    return '';
};
exports.convertFractionToChar = convertFractionToChar;
/* Since inches in sewing are generally be rounded down, the
 * intervals are skewed towards rounding down, but have a window
 * to round up (0.004) to account for floating point error.
 * Adjust the window (0.004) as needed.
 */
exports.fractionEstimateIntervals = [
    { fraction: '1/64', interval: [0.0, 0.0313] },
    { fraction: '1/32', interval: [0.0313, 0.0469] },
    { fraction: '3/64', interval: [0.0469, 0.0585] },
    { fraction: '1/16', interval: [0.0585, 0.096] },
    { fraction: '1/10', interval: [0.096, 0.107] },
    { fraction: '1/9', interval: [0.107, 0.121] },
    { fraction: '1/8', interval: [0.121, 0.139] },
    { fraction: '1/7', interval: [0.139, 0.162] },
    { fraction: '1/6', interval: [0.162, 0.196] },
    { fraction: '1/5', interval: [0.196, 0.246] },
    { fraction: '1/4', interval: [0.246, 0.329] },
    { fraction: '1/3', interval: [0.329, 0.371] },
    { fraction: '3/8', interval: [0.371, 0.396] },
    { fraction: '2/5', interval: [0.396, 0.496] },
    { fraction: '1/2', interval: [0.496, 0.596] },
    { fraction: '3/5', interval: [0.596, 0.621] },
    { fraction: '5/8', interval: [0.621, 0.662] },
    { fraction: '2/3', interval: [0.662, 0.746] },
    { fraction: '3/4', interval: [0.746, 0.796] },
    { fraction: '4/5', interval: [0.796, 0.829] },
    { fraction: '5/6', interval: [0.829, 0.871] },
    { fraction: '7/8', interval: [0.871, 0.896] },
    { fraction: '9/10', interval: [0.896, 0.996] }
];
/**
 * Given a decimal, check if it falls into an interval of a common fraction defined above
 * @param val inches in decimal
 * @param index index into intervals array, used for recursive interval searching
 * @returns string fraction associated with decimal's corresponding interval
 */
const getEstimatedFraction = (val, index = 11) => {
    if (val === 0)
        return '';
    if (val > exports.fractionEstimateIntervals[index].interval[0] &&
        val <= exports.fractionEstimateIntervals[index].interval[1]) {
        return exports.fractionEstimateIntervals[index].fraction;
    }
    else if (val < exports.fractionEstimateIntervals[index].interval[0])
        return exports.getEstimatedFraction(val, index - 1);
    else if (val >= exports.fractionEstimateIntervals[index].interval[1])
        return exports.getEstimatedFraction(val, index + 1);
    return '';
};
exports.getEstimatedFraction = getEstimatedFraction;
//# sourceMappingURL=fractionUtils.js.map